import { Component } from 'react';
import { connect } from 'react-redux';
import { showSearchBar, hideSearchBar } from '../../actions/masterbrand';

if (process.browser) require('./SearchBar.scss');

const mapDispatchToProps = {
  show: showSearchBar,
  hide: hideSearchBar
};

class SearchBar extends Component {
  componentWillMount() {
    this.props.show();
  }

  componentWillUnmount() {
    this.props.hide();
  }

  render() {
    return null;
  }
}

export default connect(() => ({}), mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchBar/SearchBar.js